<template>	
    <div>   
        <div class="p-fluid p-formgrid p-grid">            
            <div class="p-col-12 p-md-12">
                <div class="p-field">
                    <label>Empresa</label>
                    <InputText v-model="cnpjSelecionado.cnpjNome" readonly v-if="cnpjSelecionado"/>
                    
                    <DataTable :value="tarefasPendentes" class="p-datatable-sm p-datatable-striped p-mt-4" v-if="tarefasPendentes.length > 0">    
                        <template #header>
                            Tarefas Pendêntes: {{ (tarefasPendentes.length > 0 ? tarefasPendentes.length : '') }}
                        </template>                          
                        <Column field="descricao" header="Descrição"></Column>
                    </DataTable>	
                    <br/><br/><br/><br/><br/><br/><br/><br/><br/>
                </div>
            </div>
        </div> 
    </div>		
</template>

<script>
import RelogioPontoService from '@/service/RelogioPontoService.js';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';

export default {
	relogioPontoService: null,      
    data() {
        return { 
            tarefasPendentes: [],
            cnpjs: [],
            cnpjSelecionado: null,         
            relogios: [],			
            respostaTarefasPushAsync: { erro: false, temPushAsync: false , relogiosPushAsync: []}
        }        
    },
	methods: {
		...mapGetters('sessao', ['getDadosRequisicao', 'getCacheEmpresa']),	       
        /**
         * 
         */
        setCnpjSelecionado(cnpj, callbackItensSincronizar) {
            this.cnpjSelecionado = cnpj;
            this.listarTarefasComServicoPushAsync(callbackItensSincronizar);
        }, 
        /**
         * 
         */
        iniciarSincronizacaoDeTarefasPendentes(callbackAposCrirarTarefas) {        
            if(this.respostaTarefasPushAsync.temPushAsync) {
                callbackAposCrirarTarefas({...this.respostaTarefasPushAsync});   
            }
        },
       /**
         * 
         */
        listarTarefasComServicoPushAsync(callbackItensSincronizar) {    
            this.tarefasPendentes = [];
            this.respostaTarefasPushAsync.erro = false;
            this.respostaTarefasPushAsync.temPushAsync = false;
            this.respostaTarefasPushAsync.relogiosPushAsync = []; 
			this.relogioPontoService.listarTarefasComServicoPushAsync(this.cnpjSelecionado.id)
			.then(resp => {					
				if(resp.data.length > 0) {
                    const tipos = [ 'NEW_USER', 'USER_UPDATE', 'DELETE_USERS', 'IMAGE_UPDATE' ];
					const tarefasPushAsync = resp.data;
                    const tarefasFiltradas = tarefasPushAsync.filter(t => tipos.includes(t.tipo));
                    const mapReps = new Map();
                    tarefasFiltradas.forEach(t => {
                        let rep = mapReps.get(t.idRelogio);
                        if(!rep) {
                            rep = {
                                id: t.idRelogio,
                                numeroCnpj: this.cnpjSelecionado.numero,
                                numeroSerie: t.numeroSerie,
                                tarefas: []
                            };
                            mapReps.set(t.idRelogio, rep);
                        }
                        rep.tarefas.push(t);
                    });
                    const relogiosPushAsync = Array.from(mapReps.values());
                    if(relogiosPushAsync.length > 0) {
                        relogiosPushAsync[0].tarefas.forEach(t => {
                            if(t.tipo == 'NEW_USER') {
                                this.tarefasPendentes.push({ descricao: 'Novos Funcionários' });
                            } else if(t.tipo == 'USER_UPDATE') {
                                this.tarefasPendentes.push({ descricao: 'Atualização de Funcionários' });
                            } else if(t.tipo == 'DELETE_USERS') {
                                this.tarefasPendentes.push({ descricao: 'Exclusão de Funcionários' });
                            } else if(t.tipo == 'IMAGE_UPDATE') {
                                this.tarefasPendentes.push({ descricao: 'Atualização de Imagens (biometria)' });
                            }
                        });
                        this.respostaTarefasPushAsync.relogiosPushAsync = [...relogiosPushAsync];                      
                        this.respostaTarefasPushAsync.temPushAsync = true;                        
                    }
				}	
                const quantidade = this.tarefasPendentes.length;	
                if(quantidade > 0) {
                    if(callbackItensSincronizar) {
                        callbackItensSincronizar(quantidade);
                    }
                }		
			}).catch(erro => {exibirMensagem(this, erro)});			
        }
	},
	created() {
		this.relogioPontoService = new RelogioPontoService();
	}
}
</script>
